var isObject = require('./_is-object');
module.exports = function (it) {
  if (!isObject(it)) throw TypeError(it + ' is not an object!');
  return it;
};



//////////////////
// WEBPACK FOOTER
// /codebuild/output/src2078029388/src/~/core-js/library/modules/_an-object.js
// module id = Ft6c
// module chunks = 6